import { render, staticRenderFns } from "./ReasonList.vue?vue&type=template&id=0f5f1bce&scoped=true&"
import script from "./ReasonList.vue?vue&type=script&lang=js&"
export * from "./ReasonList.vue?vue&type=script&lang=js&"
import style0 from "./ReasonList.vue?vue&type=style&index=0&id=0f5f1bce&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f1bce",
  null
  
)

export default component.exports